import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const useTitles = () => {
	const titles = useSelector((state) => state.masterData.titles);
	const [titleOptions, setTitleOptions] = useState([]);
	const [t] = useTranslation();

	useEffect(() => {
		const titleCopy = [...titles];
		setTitleOptions(
			titleCopy.map((item) => {
				let newItem = { ...item };
				newItem.title = t('master_data.title.' + item.user_title_i18n_key);
				return newItem;
			})
		);
	}, [titles]);

	return titleOptions;
};

export default useTitles;
